import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { standardCheckoutRoutes } from "@jti/fe-common";
import { useSelector } from "@jti/store";
import { useTranslations } from "@jti/ui";
import { CheckoutAside } from "../../components/CheckoutAside";
import { CheckoutProgressGtmObserver } from "../../components/CheckoutProgressGtmObserver";
import { HeaderWithBreadcrumbs } from "../../components/HeaderWithBreadcrumbs";
import { CheckOutSteps } from "../../constants/checkout-constants";
import { useFreeTrial } from "../../hooks/useFreeTrial";
import { useRedirectToTrialProductsFromTrialCheckout } from "../../hooks/useRedirectToTrialProductsFromTrialCheckout";
import { PageBaseLayout } from "../../layouts/PageBaseLayout";
import { DeliveryPageContent } from "./components/DeliveryPageContent";
export const DeliveryPage = () => {
    useRedirectToTrialProductsFromTrialCheckout();
    const { __ } = useTranslations();
    const history = useHistory();
    const { isFreeTrial } = useFreeTrial();
    const asideSubmitButtonWrapperRef = useRef(null);
    const { shippingStepData } = useSelector((state) => state.standardCheckoutForm);
    useEffect(() => {
        if (!shippingStepData) {
            history.replace(standardCheckoutRoutes.root);
        }
    }, [shippingStepData]);
    return (_jsxs(_Fragment, { children: [_jsx(CheckoutProgressGtmObserver, { step: CheckOutSteps.Delivery }), _jsx(PageBaseLayout, { header: _jsx(HeaderWithBreadcrumbs, { title: __(!isFreeTrial ? "cart.title.checkout" : "cart.title.freeTrial"), step: CheckOutSteps.Delivery }), content: _jsx(DeliveryPageContent, { asideSubmitButtonWrapperRef: asideSubmitButtonWrapperRef }), aside: _jsx(CheckoutAside, { submitButtonWrapperRef: asideSubmitButtonWrapperRef }), "data-testid": "delivery-page" })] }));
};
//# sourceMappingURL=DeliveryPage.js.map